"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('middle-finger', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M14.972 26.9745C11.6512 27.5662 9.99084 29.5748 9.99084 33.0002C9.99084 38.1383 15.1439 44.0002 19.7906 44.0002C24.4373 44.0002 27.1322 44.0002 31.6803 44.0002C36.2284 44.0002 38.9908 40.1496 38.9908 37.0603C38.9908 32.7099 38.9908 28.3596 38.9908 24.0093C38.9908 22.3524 37.6477 21.0093 35.9908 21.0093H35.9818C34.3299 21.0093 32.9908 22.3484 32.9908 24.0002",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M14.972 30.0401V21.013C14.972 19.3546 16.3163 18.0103 17.9747 18.0103C17.9757 18.0103 17.9768 18.0103 17.9778 18.0103C19.6384 18.012 20.9837 19.3586 20.9837 21.0192V25.0229",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M20.9837 24.0083V7.01549C20.9837 5.35008 22.3338 4 23.9992 4C25.6646 4 27.0146 5.35008 27.0146 7.01549V24.0083",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M26.9908 23.7158V21.0034C26.9908 19.3466 28.334 18.0034 29.9908 18.0034C31.6477 18.0034 32.9908 19.3466 32.9908 21.0034V24.0034",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;